import { Autocomplete, TextField } from "@mui/material";
import { trackEventMatomo } from "../../../../helpers/matomo";
import { useContext, useEffect } from "react";
import { Checkbox, Chip, Typography } from "@material-ui/core";
import { SubItemFormFilling } from "../../../Filling/Types";
import CheckIcon from "../../CheckIcon";
import AdditionalInfo from "../../Structure/AdditionalInfo";
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { NewWebFormContext } from "../../../../context/NewWebFormContext";

type props = {
  subitem: SubItemFormFilling,
  unico: string | null,
  setUnico: Function,
}

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function AutoCompleteUnique({
  subitem,
  unico,
  setUnico }: props) {
  const { ForceUpdate } = useContext(NewWebFormContext);

  const textFieldTitle: string = (() => {
    let title = ''
    if (CheckIcon(subitem, unico) === 'naoOk') {
      title += '* '
    }
    title += `${subitem.id + 1} - ${subitem.nome}`;
    return title;
  })()

  useEffect(() => {
    if (subitem.selecionados) {
      (subitem.selecionados as boolean[])?.find((ele, index: number) => {
        if (ele === true) {
          setUnico((subitem.selecao as string[])[index]);
        }
      })
    }
  }, [])

  useEffect(() => {
    if (subitem.padrao) {
      setUnico((subitem.selecao as string[])[subitem.padrao])
      const novo = Array(subitem?.selecao?.length)?.fill(false)
      novo[subitem.padrao] = true
      subitem.selecionados = novo
    } if (CheckIcon(subitem, unico) === 'ok') {
      subitem.checked = true
    }
  }, [])

  useEffect(() => {
    const novo = Array(subitem?.selecao?.length)?.fill(false)
    const index = subitem.selecao?.indexOf(unico as string)
    novo[index as number] = true
    subitem.selecionados = novo
    if (CheckIcon(subitem, unico) === 'ok') {
      subitem.checked = true
    } else {
      delete subitem.checked
    }
    ForceUpdate()
  }, [unico])

  return (
    <>
      <Typography
        variant='h6'
        style={{
          wordBreak: 'break-all',
          marginBottom: '5px',
          width: '100%',
          textAlign: 'left'
        }}>
        {textFieldTitle}
      </Typography>
      <Autocomplete
        style={{
          width: '100%',
          height: '100%',
          backfaceVisibility: 'hidden',
        }}
        renderOption={(props, option, { selected }) => {
          const { key, ...optionProps } = props;
          return (
            <li key={key} {...optionProps}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option}
            </li>
          );
        }}
        disableCloseOnSelect
        className={`${subitem.itemid}|${subitem.id}`}
        onClick={() => trackEventMatomo('formSubitem', 'click', 'input', 'edita valor')}
        noOptionsText={'Sem opções...'}
        loadingText={'Carregando...'}
        autoComplete
        value={unico || null}
        getOptionLabel={option => option as string}
        isOptionEqualToValue={(option, value) => option === value}
        fullWidth={true}
        options={
          subitem?.selecao?.map((option) => option) || []
        }
        onChange={(event: any, newValue: string | number | null) => {
          event.preventDefault()
          setUnico(newValue)
          if (!newValue) {
            setUnico(null)
            delete subitem.selecionados
          }

        }}
        renderInput={(params) =>
          <TextField
            required={subitem.obrigatoriedade?.preenchimento}
            {...params}
            placeholder="Selecione o valor"
            InputLabelProps={{ shrink: true }}
          />}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              label={option}
              {...getTagProps({ index })}
              style={{
                maxWidth: 200,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
              key={index}
            />
          ))
        }
      />
      {(subitem.foto || subitem.comentario) && unico && <AdditionalInfo subItem={subitem} />}
    </>
  )
}